import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { ColumnExportButton, Table } from 'barnyard/components';


const NewVendorTable = ({ credentials, includeExport }) => {
  const columns = [{
    Header: 'Date',
    id: 'date',
    accessor: row => moment(row.date).format('MMMM Do, YYYY')
  }, {
    Header: 'Supplier',
    accessor: 'supplier_name',
  }, {
    Header: 'Username',
    accessor: 'username',
  }];

  return (
    <Table
      actions={includeExport && (
        <div className='u-paddingTop10'>
          <ColumnExportButton
            filename='Vetcove_New_Vendor_Added.csv'
            data={credentials}
            columns={columns}
          >
            Download
          </ColumnExportButton>
        </div>
      )}
      size='small'
      columns={columns}
      data={credentials}
      pageSize={credentials.length || 10}
      showPagination={false}
    />
  );
};

NewVendorTable.propTypes = {
  credentials: PropTypes.array.isRequired,
  includeExport: PropTypes.bool
};

export default NewVendorTable;
